var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputArrowNewFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.854 3.509l.353.354-.353.353-3.5 3.491L4.646 7 7.3 4.353H0v-1h7.285L4.646.707 5.354 0l3.5 3.509z",
    fill: "currentColor"
  })));
}
export default SvgInputArrowNewFooter;